import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {MumaEntity, MumaEntityMachtigingStatus, MumaRequestDienst} from "@snelstart-ventures/fiscaal/domain-logic";

@Injectable({providedIn: 'root'})
export class BokkzMumaDataService implements OnDestroy {

  public mumaList = new BehaviorSubject<MumaEntity[]>(this.getFromSessionStorage<MumaEntity[]>('mumaList') || <MumaEntity[]>{});
  public mumaEntity = new BehaviorSubject<MumaEntity>(this.getFromSessionStorage<MumaEntity>('mumaEntity') || <MumaEntity>{});
  public activatieCode = new BehaviorSubject<string>("");
  public isOpvoeren = new BehaviorSubject<boolean>(false);
  public isActiveren = new BehaviorSubject<boolean>(false);
  public isIntrekken = new BehaviorSubject<boolean>(false);

  constructor() {
    this.applyDebounceTime();
  }

  private applyDebounceTime() {
    const debounceDelay = 500; // Timeout voor toetsaanslagen
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private saveToSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  updateMumaList(mumaList: MumaEntity[]) {
    this.mumaList.next(mumaList)
  }

  updateMumaEntity(mumaEntity: MumaEntity) {
    this.mumaEntity.next(mumaEntity)
    if (mumaEntity.machtigingStatus === MumaEntityMachtigingStatus.ACTIEF) {
      this.isIntrekken.next(true)
      this.isOpvoeren.next(false)
      this.isActiveren.next(false)
    }
    else if (mumaEntity.machtigingStatus === MumaEntityMachtigingStatus.NIET_ACTIEF) {
      this.isOpvoeren.next(true)
      this.isIntrekken.next(false)
      this.isActiveren.next(false)
    }
    else if (mumaEntity.machtigingStatus === MumaEntityMachtigingStatus.UNKNOWN) {
      this.isOpvoeren.next(true)
      this.isIntrekken.next(false)
      this.isActiveren.next(false)
    }
    else if (mumaEntity.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && this.checkIsOptInMachtiging(mumaEntity.mumaRequest?.dienst)) {
      this.isActiveren.next(true)
      this.isOpvoeren.next(false)
      this.isIntrekken.next(false)
    }
    else if (mumaEntity.machtigingStatus === MumaEntityMachtigingStatus.AFGEKEURD) {
      this.isOpvoeren.next(true)
      this.isIntrekken.next(false)
      this.isActiveren.next(false)
    }
    else {
      this.isOpvoeren.next(false)
      this.isIntrekken.next(false)
      this.isActiveren.next(false)
    }
  }

  public checkIsOptInMachtiging(dienst?: MumaRequestDienst) {
    return dienst?.toString().includes('SBA_TSG')
      || dienst?.toString().includes('VIA')
      || dienst?.toString().includes('DoMa')
  }

  updateActivatieCode(code: string) {
    this.activatieCode.next(code)
  }

  ngOnDestroy(): void {
    if (this.mumaList) {
      this.mumaList?.unsubscribe()
    }
    if (this.mumaEntity) {
      this.mumaEntity?.unsubscribe()
    }
    if (this.isIntrekken) {
      this.isIntrekken?.unsubscribe()
    }
    if (this.isActiveren) {
      this.isActiveren?.unsubscribe()
    }
    if (this.isOpvoeren) {
      this.isOpvoeren?.unsubscribe()
    }
  }
}
